/* eslint-disable max-lines-per-function */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import * as xlsx from 'xlsx/xlsx.mjs'
import Table from '../../../components/layout/Table'
import Modal from '../../../components/popup/Modal'
import { exportExcel } from '../../../utils/excel'

const CheckTrung = (props) => {
  const [errors, setErrors] = useState([])
  const [errorCot, setErrorCot] = useState([])
  const [visible, setVisible] = useState(false)
  const toggle = () => setVisible(!visible)
  const { colsTemp } = props
  const column = colsTemp.map((item) => {
    return { value: item, name: item }
  })
  useEffect(() => !visible && setErrors([]), [visible])
  const importExcel = async (event) => {
    const { files } = event.target
    const reader = new FileReader()

    const readFile = (file) => {
      return new Promise((resolve) => {
        reader.onload = (e) => {
          const wb = xlsx.read(e.target.result, { type: 'array' })
          const loiCot = []
          let importedData = []
          wb.SheetNames.forEach((wsname) => {
            const ws = wb.Sheets[wsname]
            const data = xlsx.utils.sheet_to_json(ws, { header: 1 })
            const cols = data[0]
            if (colsTemp && JSON.stringify(colsTemp) !== JSON.stringify(cols)) {
              for (let i = 0; i < cols.length; i++) {
                if (colsTemp[i] !== cols[i]) {
                  if (colsTemp[i]) {
                    loiCot.push({
                      loi: (
                        <p>
                          File <b>{file.name}</b> sheet <b>{wsname}</b> cột <b>{cols[i]}</b> đổi
                          thành <b>{colsTemp[i]}</b>
                        </p>
                      ),
                    })
                  } else {
                    loiCot.push({
                      loi: (
                        <p>
                          File <b>{file.name}</b> sheet <b>{wsname}</b> cột thừa <b>{cols[i]}</b>
                        </p>
                      ),
                    })
                  }
                }
              }
              for (let i = 0; i < colsTemp.length; i++) {
                if (!cols[i]) {
                  loiCot.push({
                    loi: (
                      <p>
                        File <b>{file.name}</b> sheet <b>{wsname}</b> thiếu cột <b>{colsTemp[i]}</b>
                      </p>
                    ),
                  })
                }
              }
            } else {
              data.shift()
              importedData = [
                ...importedData,
                ...data
                  .filter((i) => i.length > 0)
                  .map((d) => {
                    return cols.reduce((obj, c, i) => {
                      obj[c] = d[i]
                      return obj
                    }, {})
                  }),
              ]
            }
          })
          resolve({ loiCot, importedData })
        }
        reader.readAsArrayBuffer(file)
      })
    }
    let submitData = []
    let cotLoi = []
    const checkData = []
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      const { loiCot, importedData } = await readFile(file)
      submitData = [...submitData, ...importedData]
      cotLoi = [...cotLoi, ...loiCot]
    }
    submitData.forEach((item) => {
      const count = checkData.find((i) => i.Sohieu === item.Sohieu)
      if (!count) {
        checkData.push({ Sohieu: item.Sohieu, datas: [item], count: 1 })
      } else {
        count.datas.push(item)
        count.count++
      }
    })
    let error = []
    checkData
      .filter((item) => item.count > 1)
      .forEach((item) => {
        error = [...error, ...item.datas]
      })
    setErrorCot(cotLoi)
    setErrors(error)
    toggle()
  }
  const json = {}
  colsTemp.forEach((item) => {
    json[item] = item
  })
  return (
    <>
      <Modal visible={visible} toggle={toggle} width="90%">
        <a
          href="#"
          className="my-3 ml-2 font-medium"
          onClick={(e) => {
            e.preventDefault()
            exportExcel(errors, 'danhSachFileLoi', json)
          }}
        >
          Xuất excel
        </a>
        <Table data={errors} column={column} />
        <Table data={errorCot} column={[{ value: 'loi', render: (item) => item.loi }]} />
      </Modal>
      <input
        onChange={importExcel}
        type="file"
        id="btn-check-trung"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        multiple
        hidden
      />
      <a
        href="#"
        className="my-3 ml-2 font-medium"
        onClick={(e) => {
          e.preventDefault()
          document.getElementById('btn-check-trung').click()
        }}
      >
        Tải các file cần kiểm tra
      </a>
    </>
  )
}

export default CheckTrung
